import React,{useEffect} from "react";
import { Link } from "react-router-dom";

import Features from "../components/features";
import AboutThree from "../components/aboutThree";
import Switcher from "../components/switcher";
import Footer from "../components/footer";

import {FiFileText, FiPauseCircle, FiCamera, FiLayout,FiMessageCircle, FiHexagon} from '../assets/icons/vander'
import NavLight from "../components/navlight";

export default function Services(){
    useEffect(() => {
        document.documentElement.setAttribute("dir", "ltr");
        document.documentElement.classList.add('dark');
        document.documentElement.classList.remove('light');
      }, []);
    const casesData = [
        {
            icon:FiFileText,
            title:'Document Intelligence',
            desc:'Securely analyze contracts, legal documents, and agreements. Extract key information, identify risks, and get instant answers to your questions while keeping sensitive data private.'
        },
        {
            icon:FiLayout,
            title:'Database Insights',
            desc:'Transform complex database queries into natural conversations. Get instant insights from your data warehouses and business intelligence tools while maintaining data sovereignty.'
        },
        {
            icon:FiMessageCircle,
            title:'Enterprise Support Bot',
            desc:'AI-powered support system that securely handles internal queries, IT support, and knowledge base management while keeping all conversations confidential.'
        },
        {
            icon:FiHexagon,
            title:'Tender Analysis',
            desc:'Automatically analyze RFPs, tenders, and procurement documents. Identify requirements, risks, and compliance needs while maintaining document confidentiality.'
        },
        {
            icon:FiCamera,
            title:'Compliance Checker',
            desc:'Ensure documents comply with regulations and internal policies. Automatically flag potential issues and suggest improvements while keeping sensitive information secure.'
        },
        {
            icon:FiPauseCircle,
            title:'Research Assistant',
            desc:'Process research papers, reports, and technical documents. Extract insights, summarize findings, and identify patterns while maintaining data privacy.'
        },
    ]
    return(
        <>
        <NavLight/>
        <section className="relative md:py-44 py-32 bg-[url('../../assets/images/bg/bg-pages.jpg')] bg-no-repeat bg-bottom bg-cover">
            <div className="absolute inset-0 bg-gradient-to-t from-slate-900 to-slate-900/70"></div>
            <div className="container relative">
                <div className="grid grid-cols-1 text-center mt-6">
                    <div>
                        <h5 className="md:text-4xl text-3xl md:leading-normal leading-normal tracking-wider font-semibold text-white mb-0">Enterprise AI Solutions</h5>
                    </div>

                    <ul className="tracking-[0.5px] mb-0 inline-block mt-5">
                        <li className="inline-block capitalize text-[15px] font-medium duration-500 ease-in-out text-white/50 hover:text-white"><Link to="/">Privix.AI</Link></li>
                        <li className="inline-block text-base text-white/50 mx-0.5 ltr:rotate-0 rtl:rotate-180"><i className="mdi mdi-chevron-right"></i></li>
                        <li className="inline-block capitalize text-[15px] font-medium duration-500 ease-in-out text-white" aria-current="page">Solutions</li>
                    </ul>
                </div>
            </div>
        </section>
        <div className="relative">
            <div className="shape absolute sm:-bottom-px -bottom-[2px] start-0 end-0 overflow-hidden z-1 text-white dark:text-slate-900">
                <svg className="w-full h-auto scale-[2.0] origin-top" viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                </svg>
            </div>
        </div>
        <section className="relative md:py-24 py-16">
            <Features classlist="container relative"/>
            <AboutThree/>
            <div className="container relative md:mt-24 mt-16">
                <div className="grid grid-cols-1 pb-6 text-center">
                    <h3 className="mb-4 md:text-3xl md:leading-normal text-2xl leading-normal font-semibold">Enterprise Use Cases</h3>

                    <p className="text-slate-400 max-w-xl mx-auto">Discover how organizations are leveraging Privix.AI to transform their operations while maintaining complete data privacy and security.</p>
                </div>

                <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 mt-6 gap-6">
                    {casesData.map((item,index)=>{
                        const Icon = item.icon
                        return(
                            <div className="p-6 rounded-md shadow dark:shadow-gray-800 group bg-white dark:bg-slate-900 hover:bg-amber-400/5 dark:hover:bg-amber-400/5 duration-500" key={index}>
                                <div className="relative overflow-hidden text-transparent -m-3">
                                    <FiHexagon className="h-24 w-24 fill-amber-400/10 group-hover:fill-amber-400/20 duration-500"/>
                                    <div className="absolute top-2/4 -translate-y-2/4 start-9 text-amber-400 rounded-xl text-2xl flex align-middle justify-center items-center">
                                        <Icon/>
                                    </div>
                                </div>
        
                                <div className="content mt-6">
                                    <Link to="" className="font-semibold text-xl hover:text-amber-400">{item.title}</Link>
                                    <p className="text-slate-400 mt-3">{item.desc}</p>
                                    <div className="mt-4">
                                        <Link to="" className="hover:text-amber-400 font-medium duration-500">Read More <i className="mdi mdi-arrow-right align-middle"></i></Link>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </section>
        <Footer/>
        <Switcher/>
        </>
    )
}